"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "app-autocomplete app-theme-bg"
  }, _vm._l(_vm.filteredAndLimitedItems, function (item) {
    return _c('div', {
      key: item.type + item.text,
      class: ['app-autocomplete-item', `app-autocomplete-type--${item.type ? item.type : 'default'}`, {
        'app-autocomplete-item--selected': item.idx === _vm.selected_idx
      }],
      on: {
        "mousedown": function ($event) {
          $event.preventDefault();
        },
        "click": function ($event) {
          return _vm.handleClick(item);
        }
      }
    }, [_c('span', {
      staticClass: "app-autocomplete-item-value"
    }, [_vm._v(_vm._s(item.text))]), item.type === 'command' ? _c('span', {
      staticClass: "u-link app-autocomplete-item-details"
    }, [_vm._v(_vm._s(item.description))]) : item.type === 'user' ? _c('span', {
      staticClass: "u-link app-autocomplete-item-details",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.openQuery(item.text);
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('send_message')))]) : item.type === 'channel' ? _c('span', {
      staticClass: "app-autocomplete-item-details"
    }, [_c('i', {
      staticClass: "fa fa-user",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(_vm._s(item.count))]) : _vm._e()]);
  }), 0);
};
var staticRenderFns = exports.staticRenderFns = [];